var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoAliplyerV2Single"},[_c('vue-aliplayer-v2',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowVideo),expression:"isShowVideo"}],ref:"VueAliplayerV2",attrs:{"options":_vm.AliplayerV2Opts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }